const AdminCreateSection = {
  createCustomer: {
    activeTabProperty: 'createCustomerActive'
  },
  createAlert: {
    activeTabProperty: 'createAlertActive'
  }
};

export default AdminCreateSection;


// WEBPACK FOOTER //
// ./app/models/adminCreateSectionTabs.js